


































import { AdcontrolProfile, Brand, Company, Product } from "@/models";
import { Component, Prop, Vue } from "vue-property-decorator";
import number from "@/filters/Number";

@Component
export default class TopListItemValue extends Vue {
  @Prop() readonly item!: Company | Brand | Product;
  @Prop({ default: null }) readonly adcontrolProfile?: AdcontrolProfile | null;
  @Prop({ default: false }) readonly shareOfVoice!: boolean;
  @Prop({ default: "count" }) readonly type?: string;

  get onlyVodProfile(): boolean {
    return this.adcontrolProfile?.mediaSourceKind === "msk_vod";
  }

  get mixedVodAndTvProfile(): boolean {
    return this.adcontrolProfile?.mediaSourceKind === "msk_vod_and_tv";
  }

  get vodPresenceOnProfile(): boolean {
    return this.onlyVodProfile || this.mixedVodAndTvProfile;
  }

  formatNumber(value: number): string {
    if ((this.type == "grp" || this.type == "grp_over_spots") && value > 0) {
      return number(value, 2);
    } else {
      return number(value);
    }
  }
}
